import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { Checkbox, TextField } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Option {
    value: string;
    label: string;
    selected?: boolean;
    // Add any other properties you need for each option
}
interface CustomStyles {
    [key: string]: string | number;
}

interface CustomAutocompleteProps {
    multiple?: boolean;
    limitTags?: number;
    id?: string;
    options: Option[];
    optionList?: any;
    disableCloseOnSelect?: boolean;
    style?: CustomStyles;
    placeholder?: string;
    onChange?: any;
    isOptionEqualToValue: any;
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
    multiple = false,
    limitTags = 0,
    id = 'autocomplete',
    options,
    optionList,
    disableCloseOnSelect = false,
    style = { width: 'auto' },
    placeholder = 'Select',
    onChange,
    isOptionEqualToValue,
}) => {
    const [selectedOption, setSelectedOption] = useState(optionList);
    const { t } = useTranslation();

    useEffect(() => {
        setSelectedOption(optionList); // Set the initial selected option
    }, []);

    return (
        <Autocomplete
            multiple={multiple}
            limitTags={limitTags}
            id={id}
            aria-label={id}
            options={options}
            value={selectedOption || null}
            size="small"
            disableClearable={true}
            disableCloseOnSelect={disableCloseOnSelect}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={isOptionEqualToValue}
            onChange={(event, value) => {
                setSelectedOption(value);
                onChange(value, id);
            }}
            style={style}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    InputProps={{
                        ...params.InputProps,
                    }}
                    placeholder={placeholder}
                />
            )}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    {multiple && (
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                    )}
                    {t(option.label)}
                </li>
            )}
        />
    );
};

export default CustomAutocomplete;
